function initialState() {
  return {
    profileStations: []
  }
}

let state = initialState()

export {
  initialState,
  state
}
